import { FC } from "react";
import NcModal from "shared/NcModal/NcModal";
import { Tab } from "@headlessui/react";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { Formatter } from "../../utils/formatters";
import RenderSidebar from "./RenderSidebar";
import { useNavigate } from 'react-router-dom';

interface RenderMainrProps {
  formik?: any;
  infoCardFocus: string;
  handleInputFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  handleError?: any;
  disableAllInputs?: boolean
}

const RenderMain: FC<RenderMainrProps> = ({
  formik,
  infoCardFocus,
  handleInputFocus,
  handleError,
  disableAllInputs = false
}) => {
  const navigate = useNavigate();

  return (
    <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8">
      <h2 className="text-3xl lg:text-4xl font-semibold">
        Atualize os dados do cartão
      </h2>
      <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
      <div>
        <div>
          <NcModal
            renderTrigger={(openModal) => (
              <span
                onClick={() => openModal()}
                className="block lg:hidden underline  mt-1 cursor-pointer"
              >
                Ver informações do cartão
              </span>
            )}
            renderContent={() => {
              return (
                <RenderSidebar infoCardFocus={infoCardFocus} formik={formik} />
              );
            }}
            modalTitle="Detalhes do cartão"
          />
        </div>
      </div>
      <div>
        <h3 className="text-2xl font-semibold">
          Informações do cartão de crédito
        </h3>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700 my-5"></div>

        <div className="mt-6">
          <Tab.Group>
            <Tab.Panels>
              <Tab.Panel className="space-y-5">
                <div className="space-y-1">
                  <Label>Número do cartão </Label>
                  <Input
                    disabled={disableAllInputs}
                    className={handleError("number", formik)}
                    value={formik.values.number}
                    onChange={(e) => {
                      const formattedNumber = Formatter.prettyNumberCredit(
                        e.target.value
                      );
                      formik.handleChange({
                        target: {
                          name: "number",
                          value: formattedNumber,
                        },
                      });
                    }}
                    onBlur={formik.handleBlur}
                    onFocus={handleInputFocus}
                    name="number"
                    placeholder="Número do cartão"
                    id="number-cart"
                    type="text"
                  />
                  {formik.errors.number && formik.touched.number && (
                    <span className="text-[#d32f2f] mt-2 mr-4 mb-0 ml-3 text-left text-xs">
                      {formik.errors.number}
                    </span>
                  )}
                </div>
                <div className="space-y-1">
                  <Label>Nome do titular </Label>
                  <Input
                    className={handleError("name", formik)}
                    name="name"
                    disabled={disableAllInputs}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onFocus={handleInputFocus}
                    id="name-cart"
                    placeholder="Nome do titular"
                    type="text"
                  />
                  {formik.errors.name && formik.touched.name && (
                    <span className="text-[#d32f2f] mt-2 mr-4 mb-0 ml-3 text-left text-xs">
                      {formik.errors.name}
                    </span>
                  )}
                </div>
                <div className="flex space-x-5  ">
                  <div className="flex-1 space-y-1">
                    <Label>Validade </Label>
                    <Input
                      type="text"
                      name="expiry"
                      disabled={disableAllInputs}
                      className={handleError("expiry", formik)}
                      value={formik.values.expiry}
                      onChange={(e) => {
                        const formattedDate = Formatter.prettyValidDateCredit(
                          e.target.value
                        );
                        formik.handleChange({
                          target: {
                            name: "expiry",
                            value: formattedDate,
                          },
                        });
                      }}
                      onBlur={formik.handleBlur}
                      onFocus={handleInputFocus}
                      id="date-cart"
                      placeholder="Validade (mês/ano)"
                    />
                    {formik.errors.expiry && formik.touched.expiry && (
                      <span className="text-[#d32f2f] mt-2 mr-4 mb-0 ml-3 text-left text-xs">
                        {formik.errors.expiry}
                      </span>
                    )}
                  </div>
                  <div className="flex-1 space-y-1">
                    <Label>CVC/CVV </Label>

                    <Input
                      name="cvc"
                      disabled={disableAllInputs}
                      id="cvv-cart"
                      className={handleError("cvc", formik)}
                      value={formik.values.cvc}
                      onChange={(e) => {
                        const formattedCVC = Formatter.prettyCVCCredit(
                          e.target.value
                        );
                        formik.handleChange({
                          target: {
                            name: "cvc",
                            value: formattedCVC,
                          },
                        });
                      }}
                      onBlur={formik.handleBlur}
                      onFocus={handleInputFocus}
                      placeholder="CVC/CVV"
                    />

                    {formik.errors.cvc && formik.touched.cvc && (
                      <span className="text-[#d32f2f] mt-2 mr-4 mb-0 ml-3 text-left text-xs">
                        {formik.errors.cvc}
                      </span>
                    )}
                  </div>
                </div>
              </Tab.Panel>
            </Tab.Panels>
          </Tab.Group>
          <div className="pt-8 gap-4 flex">
            <ButtonPrimary
              className="bg-neutral-200 border hover:bg-neutral-300 text-neutral-700 hover:text-neutral-800 dark:bg-transparent dark:text-neutral-200 dark:hover:text-neutral-300 dark:border-neutral-700"
              onClick={() => navigate(-1)}
            >
              Voltar
            </ButtonPrimary>
            <ButtonPrimary
              className="bg-[--blue] hover:bg-[--blue-dark]"
              type="submit"
              onClick={formik.submitForm}
            >
              Confirmar Dados
            </ButtonPrimary>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RenderMain;
